import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Toaster } from "./ui/sonner";
import { toast } from "sonner";
import { getApiBase } from "../lib/apiBase";

const logoPath = "/assets/bimcubes-entry-logo.png";

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    try {
      const API = getApiBase();
      await axios.post(
        `${API}/api/admin-auth/login`,
        { identifier, password },
        { withCredentials: true }
      );
      await axios.get(`${API}/api/admin-auth/me`, { withCredentials: true });
      toast.success("Connexion administrateur réussie.");
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(err.response?.data?.detail || "Identifiant ou mot de passe incorrect");
    }
  };

  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top,_rgba(190,242,100,0.12),_transparent_28%),linear-gradient(180deg,_#fbfdf8_0%,_#f8fcf3_44%,_#ffffff_100%)] px-6 py-12" data-testid="admin-login-page">
      <div className="mx-auto flex min-h-[80vh] max-w-xl items-center justify-center">
        <Card className="w-full rounded-[2.2rem] border border-[#d9e7d5]/90 bg-white/92 shadow-[0_30px_90px_-56px_rgba(15,118,110,0.32)]" data-testid="admin-login-card">
          <CardContent className="p-10 sm:p-12">
            <img alt="Bimcubes" className="mx-auto h-auto w-56 object-contain" data-testid="admin-login-logo" src={logoPath} />
            <div className="mt-8 text-center">
              <div className="text-sm font-semibold uppercase tracking-[0.22em] text-[#0f766e]" data-testid="admin-login-eyebrow">Accès protégé</div>
              <h1 className="bim-display mt-4 text-4xl font-semibold tracking-tight text-slate-950" data-testid="admin-login-title">Connexion administrateur</h1>
            </div>

            <form className="mt-8 grid gap-5" onSubmit={handleSubmit}>
              <div>
                <Label htmlFor="admin-identifier-input">Identifiant</Label>
                <Input data-testid="admin-identifier-input" id="admin-identifier-input" onChange={(e) => setIdentifier(e.target.value)} value={identifier} />
              </div>
              <div>
                <Label htmlFor="admin-password-input">Mot de passe</Label>
                <Input data-testid="admin-password-input" id="admin-password-input" onChange={(e) => setPassword(e.target.value)} type="password" value={password} />
              </div>
              {error ? <p className="text-sm text-[#b91c1c]" data-testid="admin-login-error">{error}</p> : null}
              <Button className="h-12 rounded-full bg-[#0f766e] text-base text-white hover:bg-[#149289]" data-testid="admin-login-submit-button" type="submit">
                Se connecter
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
      <Toaster closeButton position="top-center" />
    </div>
  );
}